import React from 'react';
import classNames from 'classnames/bind';
import { Picture } from "../../../Picture";
import { Gallery } from "../Gallery";
import { Slider } from "../Slider";
import style from "./styles.module.pcss";
var cx = classNames.bind(style);
var FALLBACK_PICTURE_LINK = 'https://static.beeline.ru/upload/images/error-content-sky.png';
export var PicturesSection = function PicturesSection(_ref) {
  var size = _ref.size,
    imgOptions = _ref.imgOptions,
    directionSlider = _ref.directionSlider,
    isProductDetails = _ref.isProductDetails,
    control = _ref.control;
  var devicePictures = imgOptions || [];
  var pictures = Array.isArray(devicePictures) ? devicePictures : [devicePictures];
  var isMobile = size === 's';
  if (!pictures.length) {
    return /*#__PURE__*/React.createElement("div", {
      className: cx('empty-slider', {
        'empty-slider--l': size === 'xl',
        'empty-slider--s': size === 's'
      })
    }, control, /*#__PURE__*/React.createElement(Picture, {
      src: FALLBACK_PICTURE_LINK
    }));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: cx('wrapper', {
      'wrapper--modal': !isProductDetails,
      'wrapper--vertical': directionSlider === 'vertical'
    })
  }, isMobile ? /*#__PURE__*/React.createElement(Slider, {
    control: control,
    pictures: pictures
  }) : /*#__PURE__*/React.createElement(Gallery, {
    control: control,
    pictures: pictures,
    size: size,
    sliderDirection: directionSlider
  }));
};